!(function () {
  "use strict";
  var e,
    r = {
      9826: function (e, r, t) {
        var n = t(2223),
          o = document
            .querySelector(".testimonial-slides")
            .getAttribute("data-delay"),
          i = o ? parseInt(o) : 8e3;
        new n.Z(".testimonial-slides .swiper", {
          effect: "fade",
          slidesPerView: 1,
          loop: !0,
          speed: 1100,
          fadeEffect: { crossFade: !0 },
          autoplay: { delay: i },
        });
      },
    },
    t = {};
  function n(e) {
    var o = t[e];
    if (void 0 !== o) return o.exports;
    var i = (t[e] = { id: e, loaded: !1, exports: {} });
    return r[e].call(i.exports, i, i.exports, n), (i.loaded = !0), i.exports;
  }
  (n.m = r),
    (e = []),
    (n.O = function (r, t, o, i) {
      if (!t) {
        var f = 1 / 0;
        for (l = 0; l < e.length; l++) {
          (t = e[l][0]), (o = e[l][1]), (i = e[l][2]);
          for (var u = !0, a = 0; a < t.length; a++)
            (!1 & i || f >= i) &&
            Object.keys(n.O).every(function (e) {
              return n.O[e](t[a]);
            })
              ? t.splice(a--, 1)
              : ((u = !1), i < f && (f = i));
          if (u) {
            e.splice(l--, 1);
            var c = o();
            void 0 !== c && (r = c);
          }
        }
        return r;
      }
      i = i || 0;
      for (var l = e.length; l > 0 && e[l - 1][2] > i; l--) e[l] = e[l - 1];
      e[l] = [t, o, i];
    }),
    (n.d = function (e, r) {
      for (var t in r)
        n.o(r, t) &&
          !n.o(e, t) &&
          Object.defineProperty(e, t, { enumerable: !0, get: r[t] });
    }),
    (n.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (n.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }),
    (n.nmd = function (e) {
      return (e.paths = []), e.children || (e.children = []), e;
    }),
    (n.j = 537),
    (function () {
      var e = { 537: 0 };
      n.O.j = function (r) {
        return 0 === e[r];
      };
      var r = function (r, t) {
          var o,
            i,
            f = t[0],
            u = t[1],
            a = t[2],
            c = 0;
          if (
            f.some(function (r) {
              return 0 !== e[r];
            })
          ) {
            for (o in u) n.o(u, o) && (n.m[o] = u[o]);
            if (a) var l = a(n);
          }
          for (r && r(t); c < f.length; c++)
            (i = f[c]), n.o(e, i) && e[i] && e[i][0](), (e[i] = 0);
          return n.O(l);
        },
        t = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      t.forEach(r.bind(null, 0)), (t.push = r.bind(null, t.push.bind(t)));
    })();
  var o = n.O(void 0, [216], function () {
    return n(9826);
  });
  o = n.O(o);
})();
